import { compare, create } from '@mizz/penny-core/entities/category'
import { validateOnSave } from '@mizz/penny-core/validation/category'
import {
  getAll,
  getById as getByIdApi,
  getByName,
  save as saveApi,
  remove as removeApi
} from '@mizz/penny-firebase/repositories/categories'
import { getCurrentUserId } from './auth'

export async function listCategories() {
  const categories = await getAll(getCurrentUserId())
  return categories.sort(compare)
}

export function getById(categoryId) {
  return getByIdApi(categoryId, getCurrentUserId())
}

export async function save(category) {
  const isValid = await validateOnSave(category)

  if (!isValid) {
    return Promise.reject(isValid)
  }

  const entity = create({
    ...category,
    name: (category.name || '').trim()
  })

  const foundCategory = await getByName(entity.name, getCurrentUserId())

  if (foundCategory && foundCategory.id !== entity.id) {
    throw 'Category with given name already exists.'
  }

  return saveApi(entity, getCurrentUserId())
}

export function remove(category) {
  return removeApi(category, getCurrentUserId())
}
